import { conversionFactors } from "./conversionFactors";

function lengthStorageKey(lengthUnitName) {
  const n = (lengthUnitName || "").toLowerCase();
  if (n.includes("mm") || n.includes("milli")) return "mm";
  return "inch";
}

function weightStorageKey(weightUnitName) {
  const n = (weightUnitName || "").toLowerCase();
  if (
    (n.includes("g") || n.includes("gram")) &&
    !n.includes("lb") &&
    !n.includes("pound")
  ) {
    return "gram";
  }
  return "pound";
}

/**
 * Convert stored length/weight from a pond detail row into the selected display system (English | Metric).
 * Mirrors graph extractors when storage keys are mm/inch and gram/pound.
 */
export function getConversionsForDisplay(detail, selectedUnit) {
  const lk = lengthStorageKey(detail?.LengthUnitName);
  const wk = weightStorageKey(detail?.WeightUnitName);
  const target = selectedUnit?.value === "Metric" ? "Metric" : "English";
  const lenFac = conversionFactors.length[lk]?.[target] ?? 1;
  const wFac = conversionFactors.weight[wk]?.[target] ?? 1;
  return {
    convertLength: (v) => parseFloat(v || 0) * lenFac,
    convertWeight: (v) => parseFloat(v || 0) * wFac,
  };
}
